module.exports = __webpack_public_path__ + "img/no_times.7cbe8402.png";